import { Users, Sparkles, MessageSquare, Calendar } from "lucide-react";

const TILES = [
    { key: "total",    label: "Total visitors",      icon: Users,         accent: "bg-[#0E2A47] text-white", testid: "vstat-total" },
    { key: "named",    label: "Named visitors",      icon: Sparkles,      accent: "bg-[#C8A24A] text-white", testid: "vstat-named" },
    { key: "messages", label: "Total messages",      icon: MessageSquare, accent: "bg-[#1A2230] text-white", testid: "vstat-messages" },
    { key: "last7",    label: "Active last 7 days",  icon: Calendar,      accent: "bg-[#7BA37F] text-white", testid: "vstat-last7" },
];

export default function VisitorStatsTiles({ stats }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {TILES.map((t) => (
                <div
                    key={t.key}
                    className="bg-white rounded-2xl border border-[#E5DFD3] p-4"
                    data-testid={t.testid}
                >
                    <div className="flex items-center justify-between">
                        <span className={`h-9 w-9 rounded-xl grid place-items-center ${t.accent}`}>
                            <t.icon className="h-4 w-4" />
                        </span>
                    </div>
                    <p className="mt-4 font-[Outfit] text-[26px] font-semibold tracking-tight">
                        {stats[t.key]}
                    </p>
                    <p className="text-[12.5px] text-[#6F6B63]">{t.label}</p>
                </div>
            ))}
        </div>
    );
}
